<template>
    <div class="date-time">
        <Popup :value="show" position="bottom" :overlay="true" :close-on-click-overlay="false" >
            <DatetimePicker
                @cancel="$emit('cancel')"
                @confirm="confirmTime"
                :value="newDateTimeVal"
                :min-date="minDate"
                :max-date="maxDate"
                :title="title"
                :type="dateType"
                :formatter="formatter"
            />
        </Popup>
    </div>
</template>

<script>

    import Moment from 'moment'
    import { Popup, DatetimePicker } from 'vant';

    export default {
        name: 'DateTime',
        props: {
            show:Boolean,
            title:{
                type: String,
                default: '请选择日期时间'
            },
            dateTime: {
                type: String,
                default: ''
            },
            minDate: {
                type: Date,
                default:() => (new Date('1970-01-01'))
            },
            maxDate: {
                type: Date,
                default:() => (new Date('2040-12-12'))
            },
            dateType: {
                type: String,
                default: 'datetime'
            }
        },
        watch:{
            dateTime:function (newVal,oldVal) {
                this.newDateTimeVal = new Date(newVal);
            }
        },
        data:function () {
            return {
                newDateTimeVal:new Date(),
            }
        },
        created(){
            let time = this.dateTime || '';
            if(time.length < 5){
                this.newDateTimeVal = new Date();
            }else {
                this.newDateTimeVal = new Date(time);
            }
        },
        methods:{
            confirmTime(val){
                if (this.dateType === 'date') {
                    this.$emit('confirmTime',Moment(val).format('YYYY-MM-DD'));
                } else {
                    this.$emit('confirmTime',Moment(val).format('YYYY-MM-DD HH:mm:ss'));
                }
            },
            formatter(type, value) {
                if (type === 'year') {
                    return `${value}年`;
                } else if (type === 'month') {
                    return `${value}月`
                }else if (type === 'day') {
                    return `${value}日`
                }else if (type === 'hour') {
                    return `${value}时`
                }else if (type === 'minute') {
                    return `${value}分`
                }
                return value;
            }
        },
        components:{Popup ,DatetimePicker}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    .date-time{
        .van-picker__confirm,.van-picker__cancel{
            color: #F84025;
        }
        .van-picker__title{
            font-size: 15px;
            color: #222;
        }
    }
</style>

